import { useEffect, useMemo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { IFRAME_ID } from "../Frames/constants";
import { createRecalculatePositions } from "../Helpers/createRecalculatePositions";
import { useIFrameDocument } from "./useIFrameDocument";

export const useAutomaticDropZoneCalculator = () => {
  const setDropZonePositions = useBuilderStore(
    state => state.setDropZonePositions,
  );
  const isDraggingEnabled = useBuilderStore(state => state.isDraggingEnabled);
  const isFloatingDropZonesEnabled = useBuilderStore(
    state => state.isFloatingDropZonesEnabled,
  );
  const iFrameDocument = useIFrameDocument(IFRAME_ID);

  const recalculatePositions = useMemo(
    () => createRecalculatePositions(setDropZonePositions),
    [setDropZonePositions],
  );

  useEffect(() => {
    if (!isDraggingEnabled || !isFloatingDropZonesEnabled) return;

    const iframeElement = document.getElementById(IFRAME_ID);

    if (!iFrameDocument || !iframeElement) return;

    const handleIframeLoad = () => {
      // We need to wait a bit for the iframe to be fully loaded and rendered,
      // before recalculating the positions
      setTimeout(() => {
        recalculatePositions();
      }, 200);
    };

    iframeElement.addEventListener("load", handleIframeLoad);

    return () => {
      iframeElement.removeEventListener("load", handleIframeLoad);
    };
  }, [
    iFrameDocument,
    isDraggingEnabled,
    isFloatingDropZonesEnabled,
    recalculatePositions,
  ]);
};
